import { Button, Card, Col, Divider, Form, notification, Row, Tabs, Typography } from "antd";
import { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import API_SERVICE from "shared/services/api-service";
// import { useEffectOnce } from "react-use";
import AlternateAccountOne from "./payout-details/AlternateAccountOne";
import AlternateAccountTwo from "./payout-details/AlternateAccountTwo";
import PrimaryAccount from "./payout-details/PrimaryAccount";
import PaySubConnectore from "./payout-details/PaySubConnectore";
import { useSelector } from "react-redux";
import { RootState } from "shared/redux/store";
import SetPayout from "./payout-details/SetPayout"
import InvoicingDetails from "./payout-details/InvoicingDetails/InvoicingDetails";
import PayoutSetting from "components/PayoutSetting/PayoutSetting";
import PayoutHistory from "components/PayoutHistory/PayoutHistory";
import { getUser } from "shared/services/Utility";

const { TabPane } = Tabs;
const { Title, Text } = Typography;
type Props = {};


const ConnectorPayoutDetails: React.FunctionComponent<{ connector: any, disableValue: any, setConnector: any}> = (props) => {
    const tenant : any = useSelector((state:RootState)=>state.tenant)      
    const [activeKey, setActiveKey] = useState("1");
    const [payoutTabKey, setPayoutTabKey] = useState("2-1"); // Track nested tab for Set Payout
    const history = useHistory();
    const [disablefieldPayout, setDisableFieldPayout] = useState(false);
    const [accountTypes, setAccountTypes] = useState({} as any);
    const [connectorDetails, setConnectorDetails] = useState(props?.connector);
    const {appColors}: any = useSelector((state: RootState) => state.common);
    const isConnectorInvoicingEnabled = tenant?.tenantInfo?.connectorInvoicingEnabled
    const [defaultPayoutConfigs, setDefaultPayoutConfigs] = useState<any[]>([]);
    const tenantId = getUser()?.businessId;
    
    let { id } = useParams() as any;

    useEffect(() => {
        getAllTypes();
        if (props?.connector){
            setConnectorDetails(props?.connector);
        }
        // Fetch default payout configs for tenant
        if (tenantId) {
            API_SERVICE.getPayoutConfigList({ id: tenantId, forConnector: false, status: "ACTIVE" })
                .then(({ data }) => {
                    setDefaultPayoutConfigs(data?.payload ?? []);
                })
                .catch(() => setDefaultPayoutConfigs([]));
        }
    }, [props.connector, tenantId]);

    const onTabChange = (key: any) => {
        setActiveKey(key);
    };
    const onPayoutTabChange = (key: any) => {
        setPayoutTabKey(key);
    };
    const getAllTypes = () => {
        API_SERVICE.getTypes()
          .then(({ data }) => {
            let filterAccountType = data.find(
              (item: any) => item.propertyName == "ACCOUNT_TYPE"
            );
            setAccountTypes(filterAccountType?.keyAndDisplayValueList);
          })
          .catch((e: any) => {
            notification.error({ message: API_SERVICE.handleErrors(e) });
          });
      }

    return (
        <Card className="custom-app-card">
            <Row>
                <Col className="btn-box" span={24}>
                    <Tabs activeKey={activeKey} onChange={onTabChange} className="dynamic-tabs" style={{'--bgColor': appColors?.appPrimaryColor ?? ""} as any}>
                        <TabPane tab="Primary A/C" key="1" >
                            <PrimaryAccount primaryAccountDetails={connectorDetails} setConnectorDetails={setConnectorDetails} disablefieldPayout={disablefieldPayout} />
                        </TabPane>
                        <TabPane tab="Set Payout" key="2" >
                            <Tabs className="nested-tabs" activeKey={payoutTabKey} onChange={onPayoutTabChange}>
                                <TabPane tab="Configure Payout" key="2-1">
                                    <PayoutSetting connector={props.connector} isFromConnector={true} defaultPayoutConfigs={defaultPayoutConfigs} />
                                </TabPane>
                                <TabPane tab="Payout History" key="2-2">
                                    <PayoutHistory connector={props.connector} payoutTabKey={payoutTabKey} />
                                </TabPane>
                            </Tabs>
                        </TabPane>
                        {id == connectorDetails?.basicDetails?.ownerConnectorUserId &&
                            <TabPane tab="Pay Sub-Connectors" key="3">
                                <PaySubConnectore  isEditable={true}/>
                            </TabPane>
                        }
                        {isConnectorInvoicingEnabled && 
                            <TabPane tab="Invoicing Details" key = "4">
                                <InvoicingDetails connectorDetails={connectorDetails} setConnector={props.setConnector}/>
                            </TabPane>
                        }
                    </Tabs>
                </Col>
            </Row>
        </Card>
    );
};

export default ConnectorPayoutDetails;